import { useState } from "react";
import { Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { COMMUNICATION_CHANNELS } from "models";
import "modules/CommunicationTemplates/components/SmsEditorModal/SmsEditorModal.scss";
import { SmsEditorModalForm } from "modules/CommunicationTemplates/components/SmsEditorModal/SmsEditorModalForm";
import { useUpdateMediumMutation } from "modules/CommunicationTemplates/hooks";

import type { GroupedCommunicationMedium } from "modules/CommunicationTemplates/queryKeys";

type SmsEditorModalProps = {
  medium: GroupedCommunicationMedium | null;
  onClose: () => void;
};

export type SMSMediumForm = Pick<GroupedCommunicationMedium, "communication_medium_id" | "message" | "car_brand" | "car_model">;

const FormHelper = createFormHelper<SMSMediumForm>();

export const SmsEditorModal = ({ onClose, medium }: SmsEditorModalProps) => {
  const [hasErrors, setHasErrors] = useState(false);

  const { mutateAsync: updateMedium, isPending: isUpdateMediumPending } = useUpdateMediumMutation();

  if (!medium || medium.channel !== COMMUNICATION_CHANNELS.SMS) return;

  const handleClose = () => {
    onClose();
    setHasErrors(false);
  };

  const validateFormData = (fields: SMSMediumForm) => {
    const hasErrors = !fields.communication_medium_id || !fields.message;
    setHasErrors(hasErrors);
    return !hasErrors;
  };

  const handleSubmit = async (fields: SMSMediumForm) => {
    if (!validateFormData(fields)) return;

    await updateMedium({ ...medium, ...fields });
    handleClose();
  };

  return (
    <Modal open={true} size="large">
      <FormHelper.Form
        onSubmit={handleSubmit}
        defaultValues={{
          communication_medium_id: medium.communication_medium_id,
          message: medium.message,
          car_brand: medium.car_brand,
          car_model: medium.car_model
        }}
      >
        <div className="SmsEditorModal">
          <SmsEditorModalForm hasErrors={hasErrors} onClose={handleClose} onSubmit={handleSubmit} medium={medium} isUpdateMediumPending={isUpdateMediumPending} />
        </div>
      </FormHelper.Form>
    </Modal>
  );
};
